import { api } from './api'

export const apiUser = {
    getUsers: (filter, page, size = 10) => {
        return api.post('web/users/filter', { filter, page, size })
    },

    // exportDriver: (filter, page, size, fileName = 'Danh sách tài xế') => api.postExcel('web/export/drivers', { filter, page, size, fileName }),

    getCreateUserOptions: () => api.get('web/users/create_options'),

    // getFilterDriverOptions: () => api.get('/web/drivers/filter_driver_options'),

    createNewUser: (params) => {
        return api.post('web/users/create', { ...params })
    },

    updateUser: (params) => {
        return api.put('web/users/update', { ...params })
    },
}
